export const normalizeArray = <T>(array: T | T[] | undefined | null): T[] => {
  if (!array) return [];

  return Array.isArray(array) ? array : [array];
};
